import { getDistinct } from "store/app/providerKeyListWDates/actions";
import { RootStateOrAny, connect, useDispatch } from "react-redux";
import {
  getAccessToken,
  getPowerBIProvider,
  PowerBIProviderModel,
} from "store/app/powerBI/actions";
import { bindActionCreators, Dispatch } from "redux";
import PowerBIReport from "components/PowerBI";
import Title from "antd/lib/typography/Title";
import styles from "./PowerBIPage.module.scss"

interface PowerBIProps {
  isFetchingDistinct: boolean;
  isFetchingProviders: boolean;
  isFetchingToken: boolean;
  getDistinct(userId: string): any;
  getAccessToken(): any;
  getPowerBIProvider(payload: PowerBIProviderModel): any;
}

const PowerBIPage = (props: PowerBIProps) => {
  return (
    <div className={styles["powerbi-page"]}>
      <div className={styles["header-title"]}>
        <Title level={4}>Provider Compensation & Performance Dashboard</Title>
      </div>
      <div>
        <PowerBIReport
          getDistinct={props.getDistinct}
          getAccessToken={props.getAccessToken}
          getPowerBIProvider={props.getPowerBIProvider}
          isFetchingDistinct={props.isFetchingDistinct}
          isFetchingProviders={props.isFetchingProviders}
          isFetchingToken={props.isFetchingToken}
        ></PowerBIReport>
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isFetchingDistinct:
    store.rootReducer.appProviderKeyListWDates.isFetchingDistinct,
  isFetchingProviders: store.rootReducer.powerBI.isFetchingProviders,
  isFetchingToken: store.rootReducer.powerBI.isFetchingToken,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getDistinct,
      getAccessToken,
      getPowerBIProvider,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PowerBIPage);
